var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploading-page"},[_c('div',{staticClass:"img-box"},[_c('h1',{attrs:{"title":_vm.content !== null ? _vm.content : 'Uploading'/* ___ */}},[_vm._v(_vm._s(_vm.content !== null ? _vm.content : 'Uploading'/* ___ */))]),_vm._v(" "),_c('img',{attrs:{"src":require('../../assets/images/loading.svg'),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4afe9281","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/uploading.vue
// module id = null
// module chunks = 